import React from 'react';
import Wrapper from './StyledPage';

export const Strategy = () => {
  return <Wrapper>Strategy</Wrapper>;
};
